import React, { Component } from "react";
import "../LeftMenu.scss";
import { Menu } from "antd";
import { Link } from "react-router-dom";
import SubMenu from "antd/es/menu/SubMenu";
import { MenuOutlined } from "@ant-design/icons";
import dash from "img/leftMenu/hier.svg";
import hier from "img/leftMenu/hier.svg";
import mat from "img/leftMenu/mat.svg";
import stock from "img/leftMenu/stock.svg";
import purchasing from "img/leftMenu/purchasing.svg?v=3";
import report from "img/leftMenu/report.svg";
import hierM from "img/leftMenu/mobilw/1.svg";
import matM from "img/leftMenu/mobilw/2.svg";
import stockM from "img/leftMenu/mobilw/stock.svg";
import reportM from "img/leftMenu/mobilw/report.svg";
import MediaQuery from "react-responsive";
import MenuList from "../MenuListItem";

const subMenu = [
  { label: "Company", link: "/companies", iconStat: "icon_1" },
  { label: "People", link: "/people", iconStat: "icon_2" },
  {
    label: "Stock Classifications",
    link: "/stock-classifications",
    iconStat: "icon_3",
  },
  { label: "Packing Types", link: "/packing-types", iconStat: "icon_4" },
  { label: "Supplier", link: "/suppliers", iconStat: "icon_5" },
  { label: "Department", link: "/departments", iconStat: "icon_6" },
  { label: "Machine", link: "/machines", iconStat: "icon_7" },
  { label: "Vehicle", link: "/vehicles", iconStat: "icon_8" },
];
const subMenu2 = [
  { label: "Material Types", link: "/material-types", iconStat: "icon_1" },
  { label: "Machines", link: "/machines", iconStat: "icon_1" },
  { label: "Bin Locations", link: "/bin-locations", iconStat: "icon_3" },
  { label: "Material Bins", link: "/bins", iconStat: "icon_4" },
  { label: "Material Details", link: "/material-details", iconStat: "icon_5" },
];
const subMenu3 = [
  { label: "Stock Receipt", link: "/stock-receipt", iconStat: "icon_1" },
  { label: "Material Request", link: "/material-request", iconStat: "icon_2" },
  {
    label: "Pending MRNs",
    link: "/material-requests/pending",
    iconStat: "icon_3",
  },
  { label: "Stock Issue", link: "/stock-issue", iconStat: "icon_4" },
  { label: "Store View", link: "/stores", iconStat: "icon_5" },
  { label: "Stock Transfer", link: "/stock-transfer", iconStat: "icon_6" },
  { label: "Stock Check", link: "/stock-check", iconStat: "icon_7" },
];
const subMenu4 = [
  {
    label: "Available Stocks",
    link: "/reports/available-stocks",
    iconStat: "icon_1",
  },
  {
    label: "Bin Wise Balance",
    link: "/reports/bin-wise-balance",
    iconStat: "icon_2",
  },
  {
    label: "Supplier Wise Balance",
    link: "/reports/supplier-wise-balance",
    iconStat: "icon_3",
  },
  {
    label: "Stock In-Out Summary",
    link: "/reports/inout-summary",
    iconStat: "icon_4",
  },
];
class TiepLeftMenuCAU extends Component {
  items;

  constructor(props) {
    super(props);
  }

  state = {
    show: true,
    show2: true,
    show3: true,
    show4: true,
  };
  clickHandle = () => {
    this.setState({
      show: true,
      show2: false,
      show3: false,
      show4: false,
    });
  };
  clickHandle2 = () => {
    this.setState({
      show2: true,
      show: false,
      show3: false,
      show4: false,
    });
  };
  clickHandle3 = () => {
    this.setState({
      show3: true,
      show: false,
      show2: false,
      show4: false,
    });
  };
  clickHandle4 = () => {
    this.setState({
      show4: true,
      show: false,
      show2: false,
      show3: false,
    });
  };
  clickHandleNew = () => {
    this.setState({
      show: false,
      show2: false,
      show3: false,
      show4: false,
    });
  };

  render() {
    return (
      <div>
        <MediaQuery query="(min-device-width: 1024px)">
          <div className="LeftMenu" data-testid="LeftMenu">
            <Menu
              key="mainMenu"
              mode="inline"
              defaultSelectedKeys={["1"]}
              defaultOpenKeys={["sub1"]}
              theme="dark"
              overflowedIndicator={<MenuOutlined />}
            >
              <Menu.Item key="1" className="dasboardw">
                <Link to="/">
                  <img className="dasboard" src={dash} />
                  <span>Dashboard</span>
                </Link>
              </Menu.Item>
              <SubMenu
                key="hierarchy"
                title="Hierarchy"
                icon={<img src={hier} className="mainMenuIcon" />}
              >
                <Menu.Item key="2">
                  <Link to="/companies">
                    <span>Company</span>
                  </Link>
                </Menu.Item>
                <Menu.Item key="company-categories">
                  <Link to="/company-categories">
                    <span>Company Types</span>
                  </Link>
                </Menu.Item>
                <Menu.Item key="3">
                  <Link to="/people">
                    <span>People</span>
                  </Link>
                </Menu.Item>
                <Menu.Item key="/roles">
                  <Link to="/roles">
                    <span>User Roles</span>
                  </Link>
                </Menu.Item>
                <Menu.Item key="/employee">
                  <Link to="/employee">
                    <span>Employee</span>
                  </Link>
                </Menu.Item>
                <Menu.Item key="/gurantees">
                  <Link to="/gurantees">
                    <span>Gurantees</span>
                  </Link>
                </Menu.Item>
                <Menu.Item key="/tax-lines">
                  <Link to="/tax-types">
                    <span>Tax Types</span>
                  </Link>
                </Menu.Item>
              </SubMenu>
              <SubMenu
                key="registration"
                title="Registration"
                icon={<img src={report} className="mainMenuIcon" />}
              >
                <Menu.Item key="doc-ast">
                  <Link to="/documents">
                    <span>TIEP Applications</span>
                  </Link>
                </Menu.Item>
              </SubMenu>
              <SubMenu
                key="material"
                title="Materials"
                icon={<img src={mat} className="mainMenuIcon" />}
              >
                <Menu.Item key="mt">
                  <Link to="/material-types">
                    <span>Material Types</span>
                  </Link>
                </Menu.Item>
              </SubMenu>
              <SubMenu
                key="stock-receipts"
                title="Stocks"
                icon={<img src={stock} className="mainMenuIcon" />}
              >
                <Menu.Item key="st-in">
                  <Link to="/stock-receipts">
                    <span>Imports</span>
                  </Link>
                </Menu.Item>
                <Menu.Item key="st-out">
                  <Link to="/stock-issue">
                    <span>Exports</span>
                  </Link>
                </Menu.Item>
                <Menu.Item key="/credit-vouchers">
                  <Link to="/credit-vouchers">
                    <span>Credit Vouchers</span>
                  </Link>
                </Menu.Item>
                <Menu.Item key="st-del">
                  <Link to="/stock-delete">
                    <span>Dispose</span>
                  </Link>
                </Menu.Item>
              </SubMenu>
              <SubMenu
                key="bom"
                title="Finished Good"
                icon={<img src={purchasing} className="mainMenuIcon" />}
              >
                <Menu.Item key="bom-boms">
                  <Link to="/bom/boms">
                    {/* <span>Finished Goods</span> */}
                    <span>Boms</span>
                  </Link>
                </Menu.Item>
                <Menu.Item key="bom-add">
                  <Link to="/bom/add">
                    <span>Forecast Calculator</span>
                  </Link>
                </Menu.Item>
                <Menu.Item key="bom-fc">
                  <Link to="/bom/forecasts">
                    <span>Forecasts</span>
                  </Link>
                </Menu.Item>
              </SubMenu>
              <SubMenu
                key="reports"
                title="Reports"
                icon={<img src={report} className="mainMenuIcon" />}
              >
                <Menu.Item key="rep-ast">
                  <Link to="/reports/available-stocks">
                    <span>Available Stocks</span>
                  </Link>
                </Menu.Item>
                <Menu.Item key="rep-al">
                  <Link to="/reports/available-liability">
                    <span>Available Liability</span>
                  </Link>
                </Menu.Item>
                <Menu.Item key="mud">
                  <Link to="/reports/mud-forms">
                    <span>MUD Forms </span>
                  </Link>
                </Menu.Item>
                <Menu.Item key="wastage">
                  <Link to="/reports/wastage">
                    <span>Wastage</span>
                  </Link>
                </Menu.Item>
              </SubMenu>
            </Menu>
          </div>
        </MediaQuery>
        <MediaQuery query="(max-device-width: 1023px)">
          <div className="mobileMenu">
            <div className="footerIcon">
              <button onClick={this.clickHandle}>
                <img src={hierM} />
              </button>
            </div>
            <div className="footerIcon">
              <button onClick={this.clickHandle2}>
                <img src={stockM} />
              </button>
            </div>
            <div className="footerIcon">
              <button onClick={this.clickHandle3}>
                <img src={matM} />
              </button>
            </div>
            <div className="footerIcon">
              <button onClick={this.clickHandle4}>
                <img src={reportM} />
              </button>
            </div>
          </div>
          <div>
            {this.state.show ? (
              <div className="mobileSubMenu" onClick={this.clickHandleNew}>
                <MenuList data={subMenu} />
              </div>
            ) : null}

            {this.state.show2 ? (
              <div className="mobileSubMenu" onClick={this.clickHandleNew}>
                <MenuList data={subMenu2} />
              </div>
            ) : null}

            {this.state.show3 ? (
              <div className="mobileSubMenu" onClick={this.clickHandleNew}>
                <MenuList data={subMenu3} />
              </div>
            ) : null}
            {this.state.show4 ? (
              <div className="mobileSubMenu" onClick={this.clickHandleNew}>
                <MenuList data={subMenu4} />
              </div>
            ) : null}
          </div>
        </MediaQuery>
      </div>
    );
  }
}

export default TiepLeftMenuCAU;
